(function($){
	$(window).on('scroll', function() {
		const scroll = $(this).scrollTop();

		if (scroll >= 100) {
			$('.c-site-header').addClass('scrolled');
		} else {
			$('.c-site-header').removeClass('scrolled');
		}
	});

   // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#mainMenu').removeClass('nav-open');

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');

            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#mainMenu').addClass('nav-open');

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').removeClass('nav-open');
	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });

	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


     //Parallax Animation
    var image = document.getElementsByClassName('obs-img');
          new trustPara(image, {
          maxTransition: 300
    });

    // Initiate aos animations
	AOS.init();

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

})(jQuery);
